import { render, staticRenderFns } from "./KurumSorgulaForm.vue?vue&type=template&id=5fe45bcc"
import script from "./KurumSorgulaForm.vue?vue&type=script&lang=ts"
export * from "./KurumSorgulaForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports